import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ActivityTypeService } from 'src/app/shared/store/activity-type/activity-type.service';
import { ActivityTypeModel } from 'src/app/shared/store/activity-type/types';
import { SubHeaderService } from 'src/app/shared/store/subheader/subheader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbService } from 'xng-breadcrumb';
import { filter } from 'rxjs/operators';
import { View } from '../../../../shared/store/view/types';
import { ViewService } from '../../../../shared/store/view/views.service';

@UntilDestroy()
@Component({
    selector: 'app-activity-type-details',
    templateUrl: './activity-type-details.component.html',
    styleUrls: ['./activity-type-details.component.scss'],
    standalone: false
})
export class ActivityTypeDetailsComponent implements OnInit, OnDestroy {
  activityTypeId: number;
  activityTypeModel$: Observable<ActivityTypeModel>;
  view$: Observable<View>;

  @Input() modalId: number;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly activityTypeService: ActivityTypeService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService
  ) {
    this.activityTypeModel$ = this.activityTypeService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.activityTypeId = this.route.snapshot.params['id'];

    if (this.modalId) this.activityTypeId = this.modalId;

    this.activityTypeService.getById.call(this.activityTypeId.toString());

    this.activityTypeModel$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x)
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@activityTypeDetails', x.name);
      });
    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x)
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'activityTypeEdit') {
          this.router.navigate([
            'Crm/ActivityTypes/Edit/',
            this.activityTypeId,
          ]);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.activityTypeService.getById.reset();
    this.breadcrumbService.set('@activityTypeDetails', ' ');
  }
}
